import {
  getPlaceOfWork,
  createPlaceOfWork,
  updatePatchPlaceOfWork,
  updatePutPlaceOfWork,
  deletePlaceOfWork,
} from '@/api/reference'

export default {
  CREATE_PLACE_OF_WORK(_, data) {
    return createPlaceOfWork(data)
  },
  FETCH_PLACE_OF_WORK({ commit }, params) {
    return getPlaceOfWork(params)
      .then(res => {
        commit('SET_PLACE_OF_WORK', res.data)
      })
  },
  UPDATE_PATCH_PLACE_OF_WORK(_, data) {
    return updatePatchPlaceOfWork(data)
  },
  UPDATE_PUT_PLACE_OF_WORK(_, data) {
    return updatePutPlaceOfWork(data)
  },
  DELETE_PLACE_OF_WORK(_, id) {
    return deletePlaceOfWork(id)
  },
  
  
  
  
  
  
}
